// Mantine
import { Button, Modal, LoadingOverlay, Text } from '@mantine/core'
import { useForm } from '@mantine/form'
import { showNotification } from '@mantine/notifications'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// UI
import AddressForm from '../ui/AddressForm'

// React
import { useEffect, useState } from 'react'

export default function RetailerDisplayAddress({ retailer, reloadRetailer }) {
    const address = retailer.shipping_address

    const { requestPatch } = useAxiosApi()

    // Edit address
    const [isModalOpened, setIsModalOpened] = useState(false)
    const openModal = () => setIsModalOpened(true)
    const closeModal = () => setIsModalOpened(false)

    // Form loading state
    const [isLoading, setIsLoading] = useState(false)

    // Initialize form with address data and validation
    const initialValues = {
        name: address?.name || '',
        company: address?.company || '',
        email: address?.email || '',
        phone: address?.phone || '',
        address1: address?.address1 || '',
        address2: address?.address2 || '',
        zip: address?.zip || '',
        city: address?.city || '',
        country_code: address?.country_code || '',
    }

    const saveAddress = async (values) => {
        setIsLoading(true)

        try {
            const addressData = {
                name: values.name,
                company: values.company,
                email: values.email,
                phone: values.phone,
                address1: values.address1,
                address2: values.address2,
                zip: values.zip,
                city: values.city,
                country_code: values.country_code,
            }

            await requestPatch(`/retailers/${retailer.id}`, {
                shipping_address: addressData,
            })

            await reloadRetailer()

            showNotification({
                title: 'Adresse mise à jour',
                message: "L'adresse de livraison a été mise à jour avec succès",
                color: 'green',
            })

            closeModal()
        } catch (error) {
            console.error('Error updating address:', error)

            showNotification({
                title: 'Erreur',
                message:
                    "Une erreur est survenue lors de la mise à jour de l'adresse",
                color: 'red',
            })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            <div className="flex flex-col items-start">
                <span className="font-medium">Adresse de livraison</span>

                {!address && (
                    <span className="text-sm text-gray-500 mt-1">
                        Aucune adresse pour le moment
                    </span>
                )}

                {address && (
                    <div className="flex flex-col text-gray-500 text-sm mt-1">
                        <span>
                            {address?.name} {address?.company}
                        </span>

                        <span>{address?.email}</span>
                        <span>{address?.phone}</span>

                        <span>{address?.address1}</span>
                        <span>{address?.address2}</span>

                        <span>
                            {address?.city} {address?.zip}{' '}
                            {address?.country_code}
                        </span>
                    </div>
                )}

                <Button variant="default" className="mt-5" onClick={openModal}>
                    Modifier l'adresse
                </Button>
            </div>

            <Modal
                opened={isModalOpened}
                onClose={closeModal}
                title="Modifier l'adresse de livraison"
                size="lg"
            >
                <div className="mb-4 relative">
                    <LoadingOverlay visible={isLoading} overlayBlur={2} />

                    <form
                        onSubmit={(e) => {
                            e.preventDefault()
                            saveAddress()
                        }}
                    >
                        <AddressForm
                            initialValues={initialValues}
                            onSubmit={saveAddress}
                        />
                    </form>
                </div>
            </Modal>
        </>
    )
}
